import AgentDistribution from './agent-distribution';

export default {
	AgentDistribution
};
